import React from 'react';
import { SMEBank, SMEGo } from '../../../Assets/images/logos';
import { Logo } from '@single-platform/components';
import LogoStyle from './logo.styles';

export const Logos = ({ isBank }) => {
  return <LogoStyle>{isBank ? <SMEBank /> : <Logo />}</LogoStyle>;
};
